var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgError(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 193.31 100",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{isolation:isolate;}.cls-2{fill:url(#linear-gradient);}.cls-3{fill:#dce8f6;opacity:0.5;}.cls-4{fill:url(#linear-gradient-2);}.cls-5{fill:url(#linear-gradient-3);}.cls-6{opacity:0.6;mix-blend-mode:color-burn;fill:url(#linear-gradient-4);}.cls-7{fill:url(#linear-gradient-5);}.cls-8{fill:#f15f5e;}.cls-9{fill:#4a1449;}.cls-10{fill:url(#linear-gradient-6);}.cls-11{fill:url(#linear-gradient-7);}.cls-12{fill:#fcb73e;}.cls-13{fill:url(#linear-gradient-8);}.cls-14,.cls-37,.cls-39{fill:#fff;}.cls-15{fill:url(#linear-gradient-9);}.cls-16{fill:url(#linear-gradient-10);}.cls-17{fill:#d1e5f6;}.cls-17,.cls-27{mix-blend-mode:multiply;}.cls-18{fill:url(#linear-gradient-11);}.cls-19{fill:url(#linear-gradient-12);}.cls-20{fill:url(#linear-gradient-13);}.cls-21{fill:url(#linear-gradient-14);}.cls-22{fill:url(#linear-gradient-15);}.cls-23{fill:#2e3168;}.cls-24{fill:url(#linear-gradient-16);}.cls-25{fill:url(#linear-gradient-17);}.cls-26{fill:url(#linear-gradient-18);}.cls-27{fill:#bcbec0;}.cls-28{fill:url(#linear-gradient-19);}.cls-29{fill:url(#linear-gradient-20);}.cls-30{fill:url(#linear-gradient-21);}.cls-31{fill:url(#linear-gradient-22);}.cls-32{fill:#204283;}.cls-33{fill:url(#linear-gradient-23);}.cls-34{fill:url(#linear-gradient-24);}.cls-35{fill:url(#linear-gradient-25);}.cls-36{fill:url(#linear-gradient-26);}.cls-37{font-size:5.55px;font-family:Rubik-Bold, Rubik;font-weight:700;}.cls-38{letter-spacing:0em;}.cls-39{stroke:#f6895d;stroke-miterlimit:10;stroke-width:4px;}.cls-40{fill:url(#linear-gradient-27);}.cls-41{fill:url(#linear-gradient-28);}.cls-42{fill:url(#linear-gradient-29);}.cls-43{fill:url(#linear-gradient-30);}.cls-44{fill:url(#linear-gradient-31);}.cls-45{fill:#f6895d;}.cls-46{fill:none;stroke:#2e3168;stroke-linecap:round;stroke-linejoin:round;}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 23.89,
    y1: 194.61,
    x2: 57.5,
    y2: 194.61,
    gradientTransform: "translate(-45.52 -133.82) rotate(-15.89)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#97cbee"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 185.83,
    y1: 152.52,
    x2: 201.36,
    y2: 152.52,
    gradientTransform: "translate(16.97 -175.81) rotate(21.98)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 46.2,
    y1: 53.83,
    x2: 143.3,
    y2: 53.83,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: -258.85,
    y1: 55.37,
    x2: -182.48,
    y2: 55.37,
    gradientTransform: "matrix(-1, 0, 0, 1, -132.04, 0)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#408dcc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#d1e5f6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-5",
    x1: 80.18,
    y1: 45.94,
    x2: 90.55,
    y2: 54.07,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#ffda8c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#fdc785"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#f79773"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f15f5e"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-6",
    x1: 59.69,
    y1: 44.97,
    x2: 67.95,
    y2: 44.97,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-7",
    x1: 58.42,
    y1: 49.47,
    x2: 69.42,
    y2: 49.47,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#f6895d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "#f16680"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-8",
    x1: 63.92,
    y1: 47.86,
    x2: 69.42,
    y2: 47.86,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fcb73e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f15f5e"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-9",
    x1: 95.85,
    y1: 20.61,
    x2: 108.03,
    y2: 20.61,
    xlinkHref: "#linear-gradient-8"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-10",
    x1: 97.97,
    y1: 20.61,
    x2: 100.31,
    y2: 20.61,
    xlinkHref: "#linear-gradient-8"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-11",
    x1: 121.87,
    y1: 21.48,
    x2: 122.42,
    y2: 21.48,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-12",
    x1: 121.87,
    y1: 35.43,
    x2: 122.42,
    y2: 35.43,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-13",
    x1: 127.61,
    y1: 28.46,
    x2: 130.63,
    y2: 28.46,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-14",
    x1: 113.66,
    y1: 28.46,
    x2: 116.68,
    y2: 28.46,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-15",
    x1: 122.14,
    y1: 38.14,
    x2: 122.14,
    y2: 18.77,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#408dcc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#97cbee"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-16",
    x1: 119.99,
    y1: 29.8,
    x2: 122.42,
    y2: 29.8,
    xlinkHref: "#linear-gradient-7"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-17",
    x1: -453.89,
    y1: -3699.01,
    x2: -447.61,
    y2: -3694.09,
    gradientTransform: "translate(-3373.42 1420.79) rotate(75.45)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#b25884"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7b2d8c"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-18",
    x1: 90.13,
    y1: 57.36,
    x2: 107.18,
    y2: 70.72,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient-17"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-19",
    x1: 393.93,
    y1: -378.36,
    x2: 401.34,
    y2: -378.36,
    gradientTransform: "translate(-386.08 313.16) rotate(15.08)",
    xlinkHref: "#linear-gradient-5"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-20",
    x1: -137.72,
    y1: -3461.05,
    x2: -123.17,
    y2: -3477.85,
    gradientTransform: "translate(-3048.69 1557.76) rotate(66.32)",
    xlinkHref: "#linear-gradient-5"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-21",
    x1: 208.81,
    y1: -97.11,
    x2: 220.4,
    y2: -97.11,
    gradientTransform: "matrix(1, 0.09, -0.09, 1, -130.23, 128.02)",
    xlinkHref: "#linear-gradient-5"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-22",
    x1: 114.49,
    y1: 92.42,
    x2: 101.85,
    y2: 62.34,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#ffda8c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#fdc785"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71,
    stopColor: "#f79773"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f15f5e"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-23",
    x1: 65.1,
    y1: 67.87,
    x2: 90.16,
    y2: 67.87,
    xlinkHref: "#linear-gradient-15"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-24",
    x1: -60.08,
    y1: 214.62,
    x2: -37.25,
    y2: 214.62,
    gradientTransform: "matrix(0.99, -0.1, 0.1, 0.99, 139.73, -159.05)",
    xlinkHref: "#linear-gradient-17"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-25",
    x1: 84.13,
    y1: 38.13,
    x2: 88.62,
    y2: 41.65,
    xlinkHref: "#linear-gradient-5"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-26",
    x1: 82.33,
    y1: 41.59,
    x2: 87.45,
    y2: 45.61,
    xlinkHref: "#linear-gradient-5"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-27",
    x1: 0,
    y1: 49.64,
    x2: 56.04,
    y2: 49.64,
    xlinkHref: "#linear-gradient-8"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-28",
    x1: 130.69,
    y1: 49.64,
    x2: 186.73,
    y2: 49.64,
    xlinkHref: "#linear-gradient-8"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-29",
    x1: 128.34,
    y1: 79.78,
    x2: 128.34,
    y2: 59.97,
    xlinkHref: "#linear-gradient-8"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-30",
    x1: 126.94,
    y1: 64.59,
    x2: 128.93,
    y2: 64.59,
    xlinkHref: "#linear-gradient-8"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-31",
    x1: 130.67,
    y1: 66.27,
    x2: 137.89,
    y2: 66.27,
    xlinkHref: "#linear-gradient-15"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "cls-1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M45.68,29c-.17-.59-.32-1.15-.47-1.67s-.31-1-.44-1.47-.27-.87-.4-1.24-.31-.9-.44-1.24c-1.14-.53-9.53-4.79-7.83-15.74,0,0,11.62,3.36,8,15.68.17.31.38.7.6,1.16.36.71.76,1.58,1.2,2.6l.66,1.63a17.69,17.69,0,0,1,.58,1.86c.15.51.31,1,.46,1.59L48.26,30l.35-1.11.14-.39c-6-12.19,2.6-17.28,2.6-17.28,4.58,13.46-.42,16.56-2.08,17.2-.06.2-.14.4-.22.62s-.23.74-.35,1.11c-.24.76-.48,1.52-.65,2.08,0,.07,0,.15-.07.21a1.63,1.63,0,0,0-.11.17,1.1,1.1,0,0,0-.09.14c.15.64.31,1.31.48,2,.09.38.19.76.27,1.15s.15.79.23,1.19c.15.81.31,1.63.47,2.46s.26,1.68.37,2.55c.06.42.1.83.15,1.25,0-.12,0-.24.07-.36s.08-.44.13-.66c.09-.45.18-.89.26-1.31s.2-.8.29-1.13a1.68,1.68,0,0,1,.06-.24l.11-.2.08-.15c-.44-2.07-1.57-10.45,7.39-15.66,0,0,4.69,11.13-7.13,16.08v.06A1.2,1.2,0,0,1,51,40c-.08.32-.18.7-.28,1.11s-.17.85-.26,1.29c0,.22-.09.44-.13.65s-.07.44-.1.64c0,.42-.09.81-.13,1.14a1,1,0,0,1,0,.24,1.12,1.12,0,0,1-.05.13c.19,1.6.37,3.22.64,4.81.13.88.34,1.75.52,2.61.1.44.23.86.34,1.28s.22.86.37,1.27l.09.28,0-.21a8.32,8.32,0,0,1,.16-.91c.06-.32.17-.63.26-1s.22-.65.35-1,.27-.58.43-.85H53s-.24-10.5,10.54-12.4c0,0,1.47,11.58-9.79,12.36l-.12.19a6.57,6.57,0,0,0-.44.88c-.13.3-.24.61-.35.92s-.18.62-.24.92-.12.6-.16.88-.06.55-.09.8,0,.24,0,.36a.06.06,0,0,0,0,0c.13.37.26.74.42,1.1l.48,1.18c.18.39.37.76.55,1.14s.36.75.54,1.11.39.72.59,1.07c.39.7.76,1.4,1.18,2l1.19,1.89.29.42c0-.16,0-.33,0-.49a7.36,7.36,0,0,1,.21-2,1.33,1.33,0,0,1,.05-.19,1.3,1.3,0,0,0,.1-.15,1.11,1.11,0,0,1,.12-.16c-.28-1.08-2.07-9,6-12.93,0,0,4.13,9.79-5.81,13V64a1.49,1.49,0,0,1,0,.18A6.43,6.43,0,0,0,58,66a5.26,5.26,0,0,0,.11,1c0,.15.08.3.11.44a.14.14,0,0,1,0,.06c.08.1.15.21.23.32l.57.8c.19.26.38.5.55.76.34.51.66,1,1,1.45.59.92,1.16,1.69,1.62,2.33.93,1.27,1.44,2,1.44,2l-1.71-1.8c-.54-.58-1.2-1.27-1.91-2.12l-.79-.9h-.11l-.18,0c-.07,0-.12-.06-.19-.08a3.4,3.4,0,0,0-.42-.15L57.8,70l-.52-.13-.55-.07a3.51,3.51,0,0,0-.55,0h-.54a4.1,4.1,0,0,0-.5,0c-.16,0-.31,0-.44,0a1.77,1.77,0,0,1-.2,0h-.1c-1.57,1.08-9,5.56-17.37-.9,0,0,8.46-8.44,17.43.43l.17,0a3.23,3.23,0,0,1,.47,0,3.08,3.08,0,0,1,.53,0h.57a5.7,5.7,0,0,1,.58.06l.58.07.55.14.52.13.22.07c-.34-.41-.63-.89-1-1.36L56.47,66.6l-1.21-1.92c-.43-.65-.81-1.36-1.21-2.08l-.6-1.08c-.09-.19-.19-.39-.28-.59h-.08c-.05,0-.08,0-.13-.06l-1.29-.6c-.47-.23-.93-.45-1.29-.61l-.08,0C48,60.09,39.89,61,34.75,52.32c0,0,11.14-4.8,16.15,7.06l1,.46,1,.47c-.18-.36-.36-.73-.53-1.1L51.85,58c-.36-.81-.62-1.66-.91-2.51-.15-.42-.26-.86-.38-1.3s-.25-.87-.35-1.31c-.14-.66-.28-1.33-.4-2l-.1-.2c-.19-.38-.38-.84-.64-1.3s-.52-1-.82-1.46c-.57-1-1.18-1.94-1.64-2.66,0-.1-.13-.17-.17-.26l-.06-.15c-1.3-.15-11-1.64-11-12.82,0,0,13.67,2.87,11.21,12.48l0,0,.2.2c.06.08.1.17.16.26.47.72,1.09,1.69,1.66,2.68.3.49.57,1,.82,1.48l.06.1c-.23-1.48-.39-3-.56-4.41-.09-.88-.2-1.75-.31-2.6s-.24-1.72-.37-2.54-.31-1.63-.46-2.42c-.08-.4-.15-.79-.22-1.18s-.19-.76-.28-1.13c-.16-.67-.32-1.32-.47-2a4.71,4.71,0,0,0-.29-.48,6.42,6.42,0,0,0-.42-.6c-.15-.2-.31-.39-.47-.57s-.34-.35-.5-.51a10.62,10.62,0,0,0-1-.82c-.07-.06-.15-.09-.21-.15l-.17-.18h0c-2,.09-8.44-.21-9.45-7.75,0,0,8.76-1,10,7.61l.13.1a13.08,13.08,0,0,1,1,.85c.17.18.35.35.52.54s.29.35.43.53c-.08-.27-.16-.53-.23-.79C46.06,30.15,45.85,29.55,45.68,29Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M43.53,74.38A56,56,0,0,1,61.8,88.71c7.74,9.58,34.6,17.88,53.26,3.7,1.78-1.35,3.34-2.56,4.71-3.64l1.94-1.53c4.4-3.8,9.3-7.56,15.24-8.09a16.85,16.85,0,0,1,2-.06c.75,0,1.51,0,2.27,0s1.52,0,2.3,0a19,19,0,0,0,6.73,0,19.71,19.71,0,0,0,2.14-.54A27.45,27.45,0,0,0,157,76.72a19,19,0,0,0,3-2,17.23,17.23,0,0,0,1.41-1.3q.74-.81,1.41-1.68c.45-.58.87-1.18,1.3-1.79a25.63,25.63,0,0,0,3.65-5.75c.31-.68.59-1.37.85-2.09s.44-1.18.65-1.78.42-1.2.61-1.82a15.65,15.65,0,0,0,1-4.45c.39-7.78-2.56-16.11-8.82-20.89-.56-.44-1.13-.86-1.72-1.26a27.21,27.21,0,0,0-14-4.52c-.7-.12-1.4-.27-2.09-.44-5.53-1.37-10.82-4.13-15.87-6.5-.44-.25-.88-.51-1.32-.75-1.76-1-3.49-2-5.34-2.93A6.63,6.63,0,0,1,120,15.59,7.15,7.15,0,0,1,118.71,14c-.32-.51-.61-1-.9-1.54L117,11a17.4,17.4,0,0,0-2.6-4,15.67,15.67,0,0,0-1.7-1.66q-.6-.46-1.23-.87c-.61-.36-1.22-.73-1.84-1.08A37,37,0,0,0,88,.56c-.73.18-1.45.37-2.16.58a40,40,0,0,0-4.23,1.48,18.74,18.74,0,0,0-2.16.93,17.45,17.45,0,0,0-9.4,12.85,16.25,16.25,0,0,0,0,2.09c0,.46.07.93.09,1.39-.18,3.89-2.68,7.05-5.37,9.76-.54.54-1.09,1.07-1.63,1.58a2.91,2.91,0,0,1-1,.83c-5.5,3.28-11.79,4.61-16,9.67-2.5,3-3.34,6.84-4.49,10.45-.14.47-.26.94-.37,1.41-1.83,7.54-1.41,15.33,2.21,19.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M135.52,45c5.14-3.47,3-10.54,2.32-15.55-.1-1.23-.25-2.44-.4-3.58a19.88,19.88,0,0,1,2.28,2.22,21.12,21.12,0,0,1,1.77,2.29c3.29,4.67,5.53,12.09.82,16.56-1.77,1.77-5.06,2.48-7.07.47A1.7,1.7,0,0,1,135.52,45Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M136.36,84.11H49.93S39.17,61.27,54.2,53.42,73.33,47.66,73,35.2,83.6,21.64,89.75,25.57s8,7.32,17.57,1.32S130.55,21.81,130.21,41s4.61,18.46,8.54,21.46S147.63,75.81,136.36,84.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M55.9,79.19h68s8.46-18-3.36-24.13-15-4.54-14.78-14.34-8.35-10.66-13.18-7.58-6.3,5.76-13.82,1-18.28-4-18,11.07S57.11,59.77,54,62.13,47,72.66,55.9,79.19Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M84.21,47.28C75.56,46.82,74,48.91,74,48.91l18,9.77L95,49.74Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M82.41,35.08h2.8a2.05,2.05,0,0,0,2-2V23.36a2.06,2.06,0,0,0-2-2.06H60.63a2.22,2.22,0,0,0-2.16,2.06V33a2.21,2.21,0,0,0,2.16,2H77.05c1.77,2.59,5.09,3.6,7.65,3.6C84.77,38.68,82.06,37.08,82.41,35.08Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "63.95 50.1 58.46 44.65 63.95 39.2 69.45 44.65 63.95 50.1"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-10",
    points: "67.95 50.2 59.69 50.2 59.69 39.75 66.52 39.75 67.95 41.16 67.95 50.2"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-11",
    points: "58.42 51.07 69.42 51.07 69.42 47.86 58.46 47.86 58.42 51.07"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-12",
    points: "62.5 47.03 58.42 44.65 58.42 51.07 63.92 47.86 62.5 47.03"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "65.34 47.03 63.92 47.86 69.42 51.07 69.42 44.65 65.34 47.03"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-14",
    points: "66.52 39.74 67.95 41.16 66.52 41.16 66.52 39.74"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-14",
    x1: 61.17,
    y1: 42.68,
    x2: 66.88,
    y2: 42.68
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M66.88,42.88H61.17a.2.2,0,0,1-.19-.2.2.2,0,0,1,.19-.19h5.71a.2.2,0,1,1,0,.39Z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-14",
    x1: 61.17,
    y1: 43.84,
    x2: 66.88,
    y2: 43.84
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M66.88,44H61.17a.2.2,0,0,1-.19-.2.2.2,0,0,1,.19-.19h5.71a.2.2,0,1,1,0,.39Z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-14",
    x1: 61.17,
    y1: 45.01,
    x2: 66.88,
    y2: 45.01
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M66.88,45.2H61.17A.2.2,0,0,1,61,45a.2.2,0,0,1,.19-.2h5.71a.2.2,0,1,1,0,.39Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M104.56,21.53V19.69h-1.47a4.77,4.77,0,0,0-.7-1.69l1-1-1.3-1.3-1,1a4.52,4.52,0,0,0-1.69-.7V14.52H97.55V16a4.52,4.52,0,0,0-1.69.7l-1-1L93.51,17l1,1a4.79,4.79,0,0,0-.71,1.69H92.38v1.84h1.47a4.83,4.83,0,0,0,.71,1.7l-1,1,1.31,1.3,1-1a4.52,4.52,0,0,0,1.69.7V26.7h1.84V25.23a4.52,4.52,0,0,0,1.69-.7l1,1,1.3-1.3-1-1a4.82,4.82,0,0,0,.7-1.7Zm-6.09,1.69a2.61,2.61,0,1,1,2.61-2.61A2.61,2.61,0,0,1,98.47,23.22Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M99.64,20.61a1.17,1.17,0,1,1-1.17-1.17A1.17,1.17,0,0,1,99.64,20.61Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M130.6,36.12a9.69,9.69,0,1,0-13.7,0A9.69,9.69,0,0,0,130.6,36.12ZM118.25,23.77a7.78,7.78,0,1,1,0,11A7.77,7.77,0,0,1,118.25,23.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M129.92,28.46a7.78,7.78,0,1,1-7.78-7.78A7.77,7.77,0,0,1,129.92,28.46Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-18",
    x: 121.87,
    y: 19.97,
    width: 0.55,
    height: 3.02
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-19",
    x: 121.87,
    y: 33.92,
    width: 0.55,
    height: 3.02
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-20",
    x: 127.61,
    y: 28.18,
    width: 3.02,
    height: 0.55
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-21",
    x: 113.66,
    y: 28.18,
    width: 3.02,
    height: 0.55
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M122.14,18.77a9.69,9.69,0,1,0,9.69,9.69A9.68,9.68,0,0,0,122.14,18.77Zm0,17.46a7.78,7.78,0,1,1,7.78-7.77A7.77,7.77,0,0,1,122.14,36.23Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-23",
    points: "123.76 31.04 121.91 28.54 121.91 24.44 122.38 24.44 122.38 28.38 124.14 30.76 123.76 31.04"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-24",
    d: "M120.17,31.32a.15.15,0,0,1-.11,0,.18.18,0,0,1,0-.25l2.07-2.68a.18.18,0,0,1,.25,0,.19.19,0,0,1,0,.26l-2.07,2.68A.16.16,0,0,1,120.17,31.32Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "M96.65,60.67l1.71-9.49a33.9,33.9,0,0,0-10.12-3.07c-.44-.06-.9-.13-1.38-.22l-2.48,9.57Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-26",
    d: "M89.29,77.6h30S117.6,60,109.9,52.14c-9-9.15-18.05-.33-18.05-.33S97.15,63.86,89.29,77.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-27",
    d: "M100.35,51.05S97,61.93,93.48,59.45l-.79-5.84"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-28",
    d: "M92.93,54l3.5,0s4.8-1.18,3.52-4.11-6.58-2-6.58-2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "M97.86,53.34c.11-.15-2-6-2.41-7.12S91.82,45,91.82,45L75.18,43a3.32,3.32,0,0,0,0,6.64L91.4,48.4c1.39-.3,2.2,2.43,2.47,3.24s1.53.52,1.53.52A5.8,5.8,0,0,1,96,53.4C96.5,54.49,97.74,53.5,97.86,53.34Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M98.25,48.31c-.38,4-2.92,4.95-5.84,4.67S85,50.91,85.34,47s4.93-7.1,7.85-6.82S98.62,44.34,98.25,48.31Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-30",
    d: "M87.78,52.31s4.9,4.95,6.74,4.85,3.63-3.31,3-6.54a1.75,1.75,0,0,0,1-2.27c-.76-3.09-2.71-.54-2.71-.54l-2.14-1.66S83.77,49,87.78,52.31Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M91.65,49s-6.38,6.78-12.25-2.86A7.7,7.7,0,0,0,85.07,42c2.07-4.5,12.32-4.88,11.7,1.85"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M92.59,54.7s2.49-1.21,3.3-.17l-2.52,1.18"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M119,64.92l-7.45,1.94,3.61,7.34-8.9.25-7.62-.07S93.17,76.7,92.84,77s-.6,2-.6,2-.4.06.66.13l4.84.33s4.22-.63,4.89-.69c.46,0,20.87.53,22.06-.5C125.48,77.55,121.66,70.7,119,64.92Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-27",
    d: "M112.53,68.8s-1-1.84-1-2c0-2.83,4.48-3.95,7.32-2l.77,1.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "M70.41,77.63a1.25,1.25,0,0,0,1.34,1.25H98.21a1.37,1.37,0,0,0,1.47-1.25v-.07a1.39,1.39,0,0,0-1.47-1.28H71.75a1.27,1.27,0,0,0-1.34,1.28Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M69.25,73.73A4.23,4.23,0,0,0,73.12,77h16a2.57,2.57,0,0,0,2.52-3.27L89.1,61.88a4.11,4.11,0,0,0-3.88-3.13h-16a2.46,2.46,0,0,0-2.52,3.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-33",
    d: "M67.71,73.73A4.23,4.23,0,0,0,71.59,77h16a2.56,2.56,0,0,0,2.52-3.27L87.56,61.88a4.1,4.1,0,0,0-3.88-3.13h-16a2.45,2.45,0,0,0-2.51,3.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M74.73,67.73A2.27,2.27,0,1,0,77,65.46,2.27,2.27,0,0,0,74.73,67.73Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-34",
    d: "M107.06,52c-5.24,1.46,3.75,15.75,3.75,15.75L119,64.92C117.53,61.75,112.3,50.5,107.06,52Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "M85.38,40.65c.13-.2,1.12-2,1.57-1.84a1.63,1.63,0,0,1,.13,2.45"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-36",
    d: "M81.37,45.15a7.14,7.14,0,0,1,3.17,1.4c1,1,2.95-1.69,3.37-2.07a2,2,0,0,0,.26-2.56c-.78-1-3.69-1.69-4-1.4s-4,3.52-2.9,4.44"
  }), /*#__PURE__*/React.createElement("text", {
    className: "cls-37",
    transform: "translate(62.93 29.73)"
  }, "ER", /*#__PURE__*/React.createElement("tspan", {
    className: "cls-38",
    x: 7.42,
    y: 0
  }, "R"), /*#__PURE__*/React.createElement("tspan", {
    x: 11.25,
    y: 0
  }, "OR")), /*#__PURE__*/React.createElement("path", {
    className: "cls-39",
    d: "M37.16,80.28a2.41,2.41,0,0,1-2.37-2.36V69H7.21a2.3,2.3,0,0,1-1.66-.7,2.27,2.27,0,0,1-.7-1.67V57.34A6,6,0,0,1,6,53.58l26.18-33a4.39,4.39,0,0,1,1.44-1.27,4.25,4.25,0,0,1,1.8-.31H48.63A2.39,2.39,0,0,1,51,21.35V55h7.53a2.27,2.27,0,0,1,1.67.7,2.3,2.3,0,0,1,.7,1.66v9.28A2.39,2.39,0,0,1,58.52,69H51v8.93a2.39,2.39,0,0,1-2.36,2.36ZM35.23,55V38.87L22.45,55Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-40",
    d: "M32.31,80.28A2.39,2.39,0,0,1,30,77.92V69H2.36a2.3,2.3,0,0,1-1.66-.7A2.27,2.27,0,0,1,0,66.62V57.34a6,6,0,0,1,1.14-3.76l26.18-33a4.39,4.39,0,0,1,1.44-1.27,4.25,4.25,0,0,1,1.8-.31H43.78a2.25,2.25,0,0,1,1.66.7,2.27,2.27,0,0,1,.71,1.66V55h7.53A2.39,2.39,0,0,1,56,57.34v9.28a2.27,2.27,0,0,1-.7,1.67,2.3,2.3,0,0,1-1.66.7H46.15v8.93a2.41,2.41,0,0,1-2.37,2.36ZM30.38,55V38.87L17.6,55Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-39",
    d: "M167.58,80.28a2.39,2.39,0,0,1-2.37-2.36V69H137.63a2.39,2.39,0,0,1-2.36-2.37V57.34a6,6,0,0,1,1.13-3.76l26.18-33A4.4,4.4,0,0,1,164,19.3a4.23,4.23,0,0,1,1.79-.31h13.23a2.39,2.39,0,0,1,2.36,2.36V55h7.53a2.25,2.25,0,0,1,1.66.7,2.27,2.27,0,0,1,.71,1.66v9.28A2.41,2.41,0,0,1,188.94,69h-7.53v8.93a2.39,2.39,0,0,1-2.36,2.36ZM165.65,55V38.87L152.87,55Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-41",
    d: "M163,80.28a2.39,2.39,0,0,1-2.37-2.36V69H133.05a2.39,2.39,0,0,1-2.36-2.37V57.34a6,6,0,0,1,1.13-3.76l26.19-33A3.44,3.44,0,0,1,161.25,19h13.22a2.39,2.39,0,0,1,2.36,2.36V55h7.53a2.39,2.39,0,0,1,2.37,2.36v9.28A2.39,2.39,0,0,1,184.36,69h-7.53v8.93a2.39,2.39,0,0,1-2.36,2.36ZM161.07,55V38.87L148.29,55Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M129.89,76.3a30.92,30.92,0,0,0-.09-5.07c-.27-2.79,0-3,1.65-5.73s1-4,2-6.13.55-1.52,2.53-3.15,4.25-1.36,4.94-3.57c0,0-.69,4.57-1.4,7.42s-.85,4.09-2.38,5.36-2,1.95-2.4,5.13a10.13,10.13,0,0,1-3.58,6.31C130.37,77.33,129.89,76.3,129.89,76.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-42",
    d: "M130.47,75.76,132.86,68s1-3.81.55-4.72-2.62-3.82-3-5.13a17.15,17.15,0,0,1-.14-4.86c.08-1.94-1.87-6.55-1.94-7.18s-.41,4.54-1.5,6.38-2.38,2.09-2,4.13-1.09,3.89-1.39,5.37a13.79,13.79,0,0,0,.63,8c1.42,3.68,2.81,7.91,4.35,8.42S130.43,76.47,130.47,75.76Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M126.91,77.15s1.63-2.78.85-4.38-2.44-1.28-2.54-4.29.7-3.44-.09-4.94a7,7,0,0,0-6.9-3.27c-3.51.52-5.64,5.89-5.64,5.89s3-3.57,4.55-2.39,1.43,1.36,1.4,2.54,1.84,3,3,3.92.2,1.55.36,4A3.63,3.63,0,0,0,126.91,77.15Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-43",
    d: "M128.8,76.09a18.54,18.54,0,0,0-.28-2.84c-.17-.9-.36-3.08-.55-5.2-.1-1.14-.2-2.33-.3-3.29-.13-1.23-.22-1.93-.32-2.61-.11-.85-.22-1.65-.38-3.37a9,9,0,0,1,1.7-5.7,10,10,0,0,0-1.4,5.67c.16,1.72.26,2.52.38,3.36.09.68.19,1.39.31,2.62.1,1,.21,2.15.31,3.3.18,2.1.37,4.28.55,5.16A9.17,9.17,0,0,1,128.8,76.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-44",
    d: "M130.67,75.35c.4-1.81,3.31-10.81,4.19-12a59.4,59.4,0,0,0,3-6.18s-1.93,5.23-2.79,6.36S130.67,75.35,130.67,75.35Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-23",
    x: 122.17,
    y: 76.65,
    width: 12.25,
    height: 2.12
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-45",
    d: "M136.05,80.21a1.52,1.52,0,0,1-1.51,1.52H67.27a1.52,1.52,0,0,1-1.51-1.52h0a1.51,1.51,0,0,1,1.51-1.51h67.27a1.51,1.51,0,0,1,1.51,1.51Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M113.49,40.25a5.75,5.75,0,1,1-5.75-5.75A5.74,5.74,0,0,1,113.49,40.25Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-14",
    points: "102.22 46.08 102.79 41.88 106.86 41.56 106.46 45.28 102.22 46.08"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-46",
    d: "M108.41,38.22c-.87.61-2.06,1.31-2.38,2.39a2,2,0,0,0,1,2.2c.45.31,1.46.82,1.9.23s-.07-1.74-.26-2.34"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-46",
    d: "M105.93,41.11c1-1.09,2.61-3.19,4.32-3.15,1.25,0,1.46,1.48,1,2.41a2.08,2.08,0,0,1-2.65,1.17c-1.06-.52-1.18-1.92-1.29-2.95"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-46",
    d: "M108.69,40.17c-.41-.52-.89-1.17-1.59-1.28a1.83,1.83,0,0,0-1.62.79c-.23.29-.58.91,0,1.07s2.29-.91,2.32-1.09"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-46",
    d: "M106.78,37.92A1.73,1.73,0,0,1,109,39a4.61,4.61,0,0,1,.29,1.95,1.85,1.85,0,0,1-.46,1.36c-.78.57-1.37-1.06-1.45-1.57a1.69,1.69,0,0,1,1.14-1.91"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-46",
    d: "M109.5,38c.67,1.18,1.37,2.58.87,4-.41,1.15-1.33,1.09-2.27.63"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-46",
    d: "M106.84,36.59c-1,.88-2.61,2.27-1.91,3.78a1.85,1.85,0,0,0,3.13.11,3.42,3.42,0,0,0,.54-1.1,2.6,2.6,0,0,0,.13-2c-.54-1.12-2,1.13-2.33,1.5"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgError);
export default __webpack_public_path__ + "static/media/error.1a556ce4b17ff2459f0be2ff26b8a4ea.svg";
export { ForwardRef as ReactComponent };